"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Alert = require("../Alert");
var _classnames = _interopRequireDefault(require("classnames"));
var _InputModule = _interopRequireDefault(require("./Input.module.css"));
var _excluded = ["alert", "isDisabled", "className", "wrapperClassName", "inputClassName", "alertClassName", "helperTextClassName", "endEnhancer", "startEnhancer", "error", "value", "label", "onChange", "helperText", "type", "size"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Enhancer = _ref => {
  var value = _ref.value;
  return /*#__PURE__*/(0, _react.createElement)('div', {
    className: _InputModule.default.Enhancer
  }, typeof value === 'object' ? value : /*#__PURE__*/_react.default.createElement("span", {
    className: _InputModule.default.EnhancerText
  }, value));
};
var Input = exports.Input = /*#__PURE__*/(0, _react.forwardRef)((_ref2, ref) => {
  var alert = _ref2.alert,
    isDisabled = _ref2.isDisabled,
    className = _ref2.className,
    wrapperClassName = _ref2.wrapperClassName,
    inputClassName = _ref2.inputClassName,
    alertClassName = _ref2.alertClassName,
    helperTextClassName = _ref2.helperTextClassName,
    endEnhancer = _ref2.endEnhancer,
    startEnhancer = _ref2.startEnhancer,
    error = _ref2.error,
    value = _ref2.value,
    label = _ref2.label,
    onChange = _ref2.onChange,
    helperText = _ref2.helperText,
    type = _ref2.type,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'large' : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded);
  // Allow overriding the type to be password only
  var trueType = type === 'password' ? 'password' : 'text';
  var handleOnChange = (0, _react.useCallback)(event => {
    if (!isDisabled) {
      onChange(event.target.value);
    }
  }, [onChange, isDisabled]);
  var status = error ? 'error' : undefined;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-disabled": isDisabled,
    className: (0, _classnames.default)(className, _InputModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(Labels, {
    className: helperTextClassName,
    label: label,
    helperText: helperText
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_InputModule.default.Wrapper, wrapperClassName),
    "data-testid": "zui-input-wrapper",
    "data-size": size,
    "data-status": status,
    "data-disabled": isDisabled ? '' : undefined
  }, startEnhancer && /*#__PURE__*/_react.default.createElement(Enhancer, {
    value: startEnhancer
  }), /*#__PURE__*/_react.default.createElement("input", _extends({
    className: (0, _classnames.default)(_InputModule.default.Input, inputClassName),
    "data-testid": "zui-input",
    onChange: handleOnChange,
    "data-size": size,
    ref: ref,
    value: value,
    disabled: isDisabled,
    type: trueType
  }, rest)), endEnhancer && /*#__PURE__*/_react.default.createElement(Enhancer, {
    value: endEnhancer
  })), alert && /*#__PURE__*/_react.default.createElement(_Alert.Alert, {
    className: alertClassName,
    variant: alert.variant,
    isFilled: true
  }, alert.text));
});
var Labels = _ref3 => {
  var className = _ref3.className,
    label = _ref3.label,
    helperText = _ref3.helperText;
  if (!label && !helperText) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(className, _InputModule.default.Labels)
  }, label && /*#__PURE__*/_react.default.createElement("label", {
    className: _InputModule.default.Label
  }, label), helperText && /*#__PURE__*/_react.default.createElement("p", {
    className: _InputModule.default.Helper
  }, helperText));
};
//# sourceMappingURL=Input.js.map